import API from '../../services/api';

const api = new API();

const URL_FRAUD_SETTINGS = '/api/fraud/settings';
const URL_FRAUD_BLACKLISTS = '/api/fraud/blacklists/';

const unwrapLegacyResponse = response => {
    if (!response || response.status !== 0) {
        return Promise.reject(response && response.value);
    }
    return response.value;
};

export function fetchFraudSettings() {
    return api
        .getJson(URL_FRAUD_SETTINGS, {
            method: 'GET',
            credentials: 'include',
            cache: false,
        })
        .then(unwrapLegacyResponse);
}

export function saveFraudSettings(changes) {
    return api
        .getJson(URL_FRAUD_SETTINGS, {
            method: 'POST',
            credentials: 'include',
            body: changes,
        })
        .then(unwrapLegacyResponse);
}

export function downloadPublisherBlacklist() {
    return api.getFile(URL_FRAUD_BLACKLISTS, {
        method: 'GET',
        credentials: 'include',
        params: { blacklist_type: 'publisher', csv: true },
    });
}
